import _ from 'lodash'
import {
  spCookieKey,
  seCookieKey,
  oktaAtCookieKey,
  oktaItCookieKey,
  yahooYCookieKey,
  yahooTCookieKey
} from '../../conf/appConf'

const getIsOktaCookie = (cookies) => {
  const isOktaCookie = [oktaAtCookieKey, oktaItCookieKey].every(key => key in cookies)
  return {
    isOktaCookie
  }
}

const getIsSupplierCookie = (cookies) => {
  const isSpCookie = spCookieKey in cookies
  return {
    isSpCookie
  }
}

const getIsSellerCookie = (cookies) => {
  const isSeCookie = seCookieKey in cookies
  const isYCookie = [yahooYCookieKey, yahooTCookieKey].every(key => key in cookies)
  return {
    isSeCookie,
    isYCookie
  }
}

const getIsMallReferer = (req) => {
  const referer = _.get(req, 'headers.referer', '')
  const isMallReferer = referer.includes('user.mall.yahoo.com')
  return isMallReferer
}

const authUtil = (req) => {
  const isMallReferer = getIsMallReferer(req)
  const cookies = _.get(req, 'cookies', {})
  const path = _.get(req, 'path', '')
  const isSellerPath = path.startsWith('/seller')
  const isSellerLoginPath = path.startsWith('/seller/login')
  const isSupplierPath = !isSellerPath
  const { isOktaCookie } = getIsOktaCookie(cookies)
  const { isSpCookie } = getIsSupplierCookie(cookies)
  const { isSeCookie, isYCookie } = getIsSellerCookie(cookies)
  const isSeller = (isSellerPath || isSeCookie)
  const isSupplier = (isSupplierPath && isSpCookie) || !isSeller
  return {
    isMallReferer,
    isSeller: isSeller || isMallReferer,
    isSupplier: isSupplier && !isMallReferer,
    isSellerPath,
    isSellerLoginPath,
    isOktaCookie: isOktaCookie && !isMallReferer,
    isYCookie: isYCookie || isMallReferer,
    isSpCookie,
    isSeCookie
  }
}

export default authUtil
